module.exports = __webpack_public_path__ + "img/0Q3B7249_Foamcore.be7e7230.jpg";